<template>
  <v-app id="app">
    <v-navigation-drawer  v-model="drawer" dark app class="pt-4" color="black" right>
      <v-list dense>
        <v-list-item @click="logout()">
          <v-list-item-icon class="mr-3"><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-content>Logout</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-card v-if="this.$route.name == 'home'" flat tile>
      <v-toolbar extended height="auto" color="black">
        <div class="d-flex flex-column align-start cont">
          <!-- <h1 style="text-align: left; font-size: 1.32rem;">DIAGEO</h1> -->
          <img
            class="diageo"
            src="./img/logo.png"
            width="75"
            alt="Logo Diageo"
          />
          <p>
            Bem vindo, <span class="text_orange">{{ user.scope ? user.scope.dsNome : "" }}</span>
          </p>
          <p>
            Faltam <span class="text_orange">{{ lastday }}</span>
            {{ this.dias > 1 ? "dias" : "dia" }} para o término desse mês.
          </p>
        </div>
        <div>
          <v-app-bar-nav-icon
            color="#FF8723"
            @click="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </div>
      </v-toolbar>
    </v-card>
    <v-main>
      <transition name="fade" mode="out-in" appear>
        <router-view> </router-view>
      </transition>
    </v-main>
  </v-app>
</template>
<style>
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .3s;
}

.fade-enter-active {
  transition-delay: .3s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
@media (max-width: 375px) {
  .cont {
    font-size: 0.9rem !important;
  }
}
.v-window__next, .v-window__prev {
  margin: 0 6px !important;
}

</style>

<script>
export default {
  name: "app",
  data() {
    return {
      drawer: false,
      dias: 20,
    };
  },
  computed: {
    user() {
      return this.$store.state.user != undefined
        ? this.$store.state.user
        : { first_name: "Meu Perfil" };
    },
    lastday() {
      var d = new Date();
      return (
        new Date(d.getYear(), d.getMonth() + 1, 0).getDate() - d.getDate() 
      );
    },
  },
  mounted() {
    var cookie = localStorage.getItem("cookieAccepted");
    if (cookie == "true") {
      this.showBottom = false;
    }
    if (this.$store.state.token !== '') { 
      this.$gtag.query('set', {
        id_usuario: this.$store.state.user.scope.idUsuario,
        session_key: this.$store.state.token
      })
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.replace("/login");
        })
        .catch(() => alert("Login invalido"));
    },
    stopYoutube() {
      const yt = this.$refs.youtube;
      if (yt != undefined) {
        yt.forEach((ref) => {
          ref.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        });
      }
    },
    aceitarTermos() {
      this.showBottom = false;
      localStorage.setItem("cookieAccepted", true);
    },

    getYoutubeEmbed(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      const id = match && match[2].length === 11 ? match[2] : null;

      if (id) {
        return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=1&enablejsapi=1`;
      }

      return null;
    },
  },

  watch: {
    sliderCardapio() {
      this.stopYoutube();
    },
    sliderPromocao() {
      this.stopYoutube();
    }
  },
};
</script>
